import React, { useEffect, useState } from 'react'
import { useFormik, Form, Field, ErrorMessage, FormikProvider } from 'formik'
import * as Yup from 'yup'
import { Row, Col, Card, Container, Button, Form as BootstrapForm } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import { config } from '../../CommonUtils/CommonURLS'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts'
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64'
import { viewImage } from '../../CommonUtils/viewImage'
import { FaEye } from 'react-icons/fa'
import CommonCardHeader from '../../CommonUtils/CommonCardHeader'

// Validation schema
const validationSchema = Yup.object().shape({
    applicationNo: Yup.string().required('Application No. is required'),
    courseCategory: Yup.string().required('Course Category is required'),
    collegeName: Yup.string().required('College Name is required'),
    studentName: Yup.string().required('Student Name is required'),
    fathersName: Yup.string().required("Father's Name is required"),
    district: Yup.string().required('District is required'),
    gender: Yup.string().required('Gender is required'),
    countryOfOrigin: Yup.string().required('Country of Origin is required'),
    // passportNumber: Yup.string().required('Passport Number is required'),
    passportNumber: Yup.string()
        .required('Passport Number is required')
        .matches(/^[A-Z]{1}[0-9]{7}$/, 'Passport number must be 1 uppercase letter followed by 7 digits (e.g., A1234567)'),
    // passportIssueDate: Yup.date().required('Passport Issue Date is required'),
    // passportExpiryDate: Yup.date().required('Passport Expiry Date is required'),
    passportIssueDate: Yup.date()
        .required('Passport Issue Date is required')
        .max(new Date(), 'Passport Issue Date cannot be in the future'),

    passportExpiryDate: Yup.date()
        .required('Passport Expiry Date is required')
        .min(Yup.ref('passportIssueDate'), 'Passport Expiry Date must be after Issue Date'),
    visaIssueDate: Yup.date()
        .required('Visa Issue Date is required')
        .max(new Date(), 'Visa Issue Date cannot be in the future'),
    visaExpiryDate: Yup.date()
        .required('Visa Expiry Date is required')
        .min(Yup.ref('visaIssueDate'), 'Visa Expiry Date must be after Issue Date'),
    dateOfBirth: Yup.date()
        .required('Date of Birth is required')
        .max(new Date(new Date().setFullYear(new Date().getFullYear() - 18)), 'Student must be at least 18 years old'),
    courseName: Yup.string().required('Course Name is required'),
    category: Yup.string().required('Category is required'),
    status: Yup.string().required('Status is required'),
    antecedentsApproved: Yup.string().required('Antecedents Approval is required'),
    academicCredentialsVerified: Yup.string().required('Academic Credentials Verification is required'),
    finalApproval: Yup.string().required('Final Approval is required'),
    photo: Yup.string().required('Photo is required'),
    passport: Yup.string().required('Passport document is required'),
    visa: Yup.string().required('Visa document is required'),
    ssc: Yup.string().required('SSC document is required'),
    sscEmbassyCertificate: Yup.string().required('SSC Embassy Certificate is required'),
    sscAPStateBoardCertificate: Yup.string().required('SSC AP State Board Certificate is required'),
    inter: Yup.string().required('INTER document is required'),
    interEmbassyCertificate: Yup.string().required('INTER Embassy Certificate is required'),
    interAPStateBoardCertificate: Yup.string().required('INTER AP State Board Certificate is required'),
    degree: Yup.string().required('DEGREE document is required'),
    degreeEmbassyCertificate: Yup.string().required('DEGREE Embassy Certificate is required'),
    degreeAPStateBoardCertificate: Yup.string().required('DEGREE AP State Board Certificate is required'),
    tc: Yup.string().required('TC document is required'),
    others: Yup.string().required('Others document is required'),
    antecedentsApprovedDoc: Yup.string().when('antecedentsApproved', {
        is: 'Yes',
        then: (schema) => schema.required('Antecedents Approved document is required'),
        otherwise: (schema) => schema.notRequired(),
    }),
    academicCredentialsApproved: Yup.string().when('academicCredentialsVerified', {
        is: 'Yes',
        then: (schema) => schema.required('Academic Credentials Approved document is required'),
        otherwise: (schema) => schema.notRequired(),
    }),
    finalApprove: Yup.string().when('finalApproval', {
        is: 'Yes',
        then: (schema) => schema.required('Final Approve document is required'),
        otherwise: (schema) => schema.notRequired(),
    }),
})

export default function OCIAdmissions() {
    const login = sessionStorage.getItem("user_id");
    const location = useLocation();
    const navigate = useNavigate();
    const formMode = location.state?.mode || "default";
    const selectedStudentData = location.state?.studentData || null;
    const userDtls = JSON.parse(sessionStorage.getItem("decodedToken")) || [];
    console.log("loginnnnnnnnnnnnn", userDtls)
    const initialValues = {
        applicationNo: '',
        collegeName: userDtls?.empl_first_name || '',
        studentName: '',
        fathersName: '',
        district: '',
        gender: '',
        countryOfOrigin: '',
        passportNumber: '',
        passportIssueDate: '',
        passportExpiryDate: '',
        visaIssueDate: '',
        visaExpiryDate: '',
        dateOfBirth: '',
        courseCategory: '',
        courseName: '',
        category: '',
        photo: '',
        status: '',
        antecedentsApproved: '',
        academicCredentialsVerified: '',
        finalApproval: '',
        passport: '',
        visa: '',
        ssc: '',
        sscEmbassyCertificate: '',
        sscAPStateBoardCertificate: '',
        inter: '',
        interEmbassyCertificate: '',
        interAPStateBoardCertificate: '',
        degree: '',
        degreeEmbassyCertificate: '',
        degreeAPStateBoardCertificate: '',
        tc: '',
        others: '',
        antecedentsApprovedDoc: '',
        academicCredentialsApproved: '',
        finalApprove: '',
    }

    const [distlist, setDistlist] = useState([]);
    const [filePreviews, setFilePreviews] = useState({});
    const [collegeCourseOptions, setCollegeCourseOptions] = useState([]);
    const [backendLockedFields, setBackendLockedFields] = useState({});
    const applyAdmissionData = (data = {}) => {
        const mappedValues = {
            applicationNo: data.application_no || data.applicationNo || '',
            collegeName: data.college_name || data.collegeName || '',
            studentName: data.student_name || data.studentName || '',
            fathersName: data.fathers_name || data.fathersName || '',
            district: data.district || '',
            gender: data.gender || '',
            countryOfOrigin: data.country_of_origin || data.countryOfOrigin || '',
            passportNumber: data.passport_number || data.passportNumber || '',
            passportIssueDate: data.passport_issue_date || data.passportIssueDate || '',
            passportExpiryDate: data.passport_expiry_date || data.passportExpiryDate || '',
            visaIssueDate: data.visa_issue_date || data.visaIssueDate || '',
            visaExpiryDate: data.visa_expiry_date || data.visaExpiryDate || '',
            dateOfBirth: data.date_of_birth || data.dateOfBirth || '',
            courseCategory: data.course || data.courseCategory || '',
            courseName: data.branch || data.courseName || '',
            category: data.category || '',
            status: data.status || '',
            antecedentsApproved: data.antecedents_approved || data.antecedentsApproved || '',
            academicCredentialsVerified: data.academic_credentials_verified || data.academicCredentialsVerified || '',
            finalApproval: data.final_approval || data.finalApproval || '',
            photo: data.photo || '',
            passport: data.passport_doc || data.passport || '',
            visa: data.visa_doc || data.visa || '',
            ssc: data.ssc_doc || data.ssc || '',
            sscEmbassyCertificate: data.ssc_embassy_certificate || data.sscEmbassyCertificate || '',
            sscAPStateBoardCertificate: data.ssc_ap_state_board_certificate || data.sscAPStateBoardCertificate || '',
            inter: data.inter_doc || data.inter || '',
            interEmbassyCertificate: data.inter_embassy_certificate || data.interEmbassyCertificate || '',
            interAPStateBoardCertificate: data.inter_ap_state_board_certificate || data.interAPStateBoardCertificate || '',
            degree: data.degree_doc || data.degree || '',
            degreeEmbassyCertificate: data.degree_embassy_certificate || data.degreeEmbassyCertificate || '',
            degreeAPStateBoardCertificate: data.degree_ap_state_board_certificate || data.degreeAPStateBoardCertificate || '',
            tc: data.tc_doc || data.tc || '',
            others: data.others_doc || data.others || '',
            antecedentsApprovedDoc: data.antecedents_approved_doc || data.antecedentsApprovedDoc || '',
            academicCredentialsApproved: data.academic_credentials_approved_doc || data.academicCredentialsApproved || '',
            finalApprove: data.final_approve_doc || data.finalApprove || '',
        };

        formik.setValues(mappedValues);
        setBackendLockedFields(
            Object.keys(mappedValues).reduce((acc, key) => {
                acc[key] = hasValue(mappedValues[key]);
                return acc;
            }, {}),
        );

        const previews = {};
        const fileFields = {
            photo: data.photo,
            passport: data.passport_doc || data.passport,
            visa: data.visa_doc || data.visa,
            ssc: data.ssc_doc || data.ssc,
            sscEmbassyCertificate: data.ssc_embassy_certificate || data.sscEmbassyCertificate,
            sscAPStateBoardCertificate: data.ssc_ap_state_board_certificate || data.sscAPStateBoardCertificate,
            inter: data.inter_doc || data.inter,
            interEmbassyCertificate: data.inter_embassy_certificate || data.interEmbassyCertificate,
            interAPStateBoardCertificate: data.inter_ap_state_board_certificate || data.interAPStateBoardCertificate,
            degree: data.degree_doc || data.degree,
            degreeEmbassyCertificate: data.degree_embassy_certificate || data.degreeEmbassyCertificate,
            degreeAPStateBoardCertificate: data.degree_ap_state_board_certificate || data.degreeAPStateBoardCertificate,
            tc: data.tc_doc || data.tc,
            others: data.others_doc || data.others,
            antecedentsApprovedDoc: data.antecedents_approved_doc || data.antecedentsApprovedDoc,
            academicCredentialsApproved: data.academic_credentials_approved_doc || data.academicCredentialsApproved,
            finalApprove: data.final_approve_doc || data.finalApprove,
        };

        Object.keys(fileFields).forEach((key) => {
            if (fileFields[key]) {
                previews[key] = {
                    file: fileFields[key],
                    name: fileFields[key],
                    size: 'Already uploaded',
                };
            }
        });

        setFilePreviews(previews);
    };

    useEffect(() => {
        fetchDistList();
        fetchCollegeCourseIntakes();
        if (formMode === "new") {
            formik.resetForm();
            setFilePreviews({});
            setBackendLockedFields({});
            return;
        }

        if (selectedStudentData) {
            applyAdmissionData(selectedStudentData);
            return;
        }

        if (login) {
            GetAfterSubmitAdmissionDetails(login);
        }
    }, [formMode, login, selectedStudentData]);

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(`${config.url.STU_URL}getdistricts`);
        setDistlist(res?.data?.scode === "01" ? res.data.districtmst : []);
    };

    const fetchCollegeCourseIntakes = async () => {
        if (!login) {
            setCollegeCourseOptions([]);
            return;
        }

        const res = await CommonAxiosGet(`${config.url.STU_URL}getcollegecoursresintake/${login}`);

        if (res?.data?.status !== true) {
            setCollegeCourseOptions([]);
            return;
        }

        const options = [];
        const seen = new Set();

        (res.data.colleges || []).forEach((item) => {
            const courseCategory = String(item?.course_cat_name || '').trim();
            const courseName = String(item?.course_name || '').trim();
            const key = `${courseCategory}__${courseName}`;

            if (!courseCategory || !courseName || seen.has(key)) {
                return;
            }

            seen.add(key);
            options.push({ courseCategory, courseName });
        });

        setCollegeCourseOptions(options);
    };

    const allowAlphabetAndSpacesOnly = (e) => {
        const charCode = e.which ? e.which : e.keyCode;
        if ((charCode >= 65 && charCode <= 90) || (charCode >= 97 && charCode <= 122) || charCode === 32) {
            return true;
        }
        e.preventDefault();
        return false;
    };

    const handleFileUpload = (e, fieldName, fileType = "pdf") => {
        const file = e.target.files[0];
        if (!file) return;

        const path = "/Uploads/OCIAdmissions/";
        const filename = fieldName;

        ImagePdfBucket(e, formik, path, fieldName, filename, fileType).then((uploadedPath) => {
            setFilePreviews({
                ...filePreviews,
                [fieldName]: {
                    file: uploadedPath,
                    name: file.name,
                    size: (file.size / 1024).toFixed(2) + " KB"
                }
            });

            formik.setFieldValue(fieldName, uploadedPath);
            formik.setFieldError(fieldName, undefined);
        });
    };

    const handleCourseCategoryChange = (courseCategory) => {
        const normalizedCategory = String(courseCategory || '');

        formik.setFieldValue('courseCategory', normalizedCategory, true);
        formik.setFieldValue('courseName', '', true);
        formik.setFieldTouched('courseCategory', true, false);
        formik.setFieldTouched('courseName', false, false);
        formik.setFieldError('courseCategory', undefined);
    };

    const handleCourseNameChange = (courseName) => {
        const normalizedCourseName = String(courseName || '');
        const matchedCourse = collegeCourseOptions.find(
            (item) => item.courseCategory === formik.values.courseCategory && item.courseName === normalizedCourseName,
        ) || collegeCourseOptions.find((item) => item.courseName === normalizedCourseName);

        formik.setFieldValue('courseName', normalizedCourseName, true);
        if (matchedCourse) {
            formik.setFieldValue('courseCategory', matchedCourse.courseCategory, true);
        }
        formik.setFieldTouched('courseCategory', true, false);
        formik.setFieldTouched('courseName', true, false);
        formik.setFieldError('courseCategory', undefined);
        formik.setFieldError('courseName', undefined);
    };

    const handleApprovalChange = (fieldName, value, dependentFieldName) => {
        formik.setFieldValue(fieldName, value, true);
        formik.setFieldTouched(fieldName, true, false);
        formik.setFieldError(fieldName, undefined);

        if (value !== 'Yes' && dependentFieldName) {
            formik.setFieldValue(dependentFieldName, '', false);
            formik.setFieldTouched(dependentFieldName, false, false);
            formik.setFieldError(dependentFieldName, undefined);
        }
    };

    const handleSubmit = (values) => {
        const payload = {
            ...values,
            course: values.courseCategory,
            branch: values.courseName,
        };

        const url = config.url.STU_URL + 'saveOciAdmissionDetails';
        CommonAxiosPost(url, payload).then((res) => {
            if (res?.data?.scode === "01") {
                successAlert2(res?.data?.message || 'Form submitted successfully!').then((isconfirmed) => {
                    if (isconfirmed) {
                        navigate('/OCIAdmissions');
                    }
                })

                setFilePreviews({});
            } else {
                failureAlert(res?.data?.message || 'Failed to submit the form. Please try again.');
            }
        }).catch((error) => {
            console.error('Error submitting form:', error);
            failureAlert('An error occurred while submitting the form. Please try again.');
        });
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: handleSubmit,
        validateOnChange: true,
        validateOnBlur: true,
    });

    const courseCategoryOptions = Array.from(new Set(collegeCourseOptions.map((item) => item.courseCategory)));
    const courseNameOptions = Array.from(
        new Set(
            collegeCourseOptions
                .filter((item) => item.courseCategory === formik.values.courseCategory)
                .map((item) => item.courseName),
        ),
    );

    useEffect(() => {
        if (formik.values.courseCategory && formik.errors.courseCategory) {
            formik.setFieldError('courseCategory', undefined);
        }

        if (formik.values.courseName && formik.errors.courseName) {
            formik.setFieldError('courseName', undefined);
        }
    }, [formik.errors.courseCategory, formik.errors.courseName, formik.values.courseCategory, formik.values.courseName]);

    const hasValue = (value) => {
        if (value === null || value === undefined) return false;
        if (typeof value === 'string') return value.trim() !== '';
        return true;
    };

    const isFieldLocked = (fieldName) => Boolean(backendLockedFields[fieldName]);

    const GetAfterSubmitAdmissionDetails = (login) => {
        const url = `${config.url.STU_URL}getOciAdmissionDetails/${login}`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.data?.length > 0) {
                applyAdmissionData(res.data.data[0]);
            } else {
                // failureAlert('No data found for this application number.');
            }
        }).catch((error) => {
            console.error('Error fetching admission details:', error);
            failureAlert('Error fetching admission details. Please try again.');
        });
    };

    return (
        <Container fluid className="py-4">
            <section className="workflow-section-surface">
                <CommonCardHeader
                    title="Overseas Admissions Form"
                    onBack={() => navigate('/OCIAdmissions')}
                />
                <div className="workflow-section-body">
                    <FormikProvider value={formik}>
                        <Form onSubmit={formik.handleSubmit}>
                            {/* Personal Information Section */}
                            <div className="mb-4">
                                <h4 className="border-bottom border-primary pb-2 text-success">
                                    👨‍🎓 Personal Information
                                </h4>
                                <Row>
                                    {/* Application No. */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Application Number <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="applicationNo"
                                            className={`form-control st-control ${formik.errors.applicationNo && formik.touched.applicationNo ? 'is-invalid' : ''}`}
                                            placeholder="Enter Application Number"
                                            // value={login}
                                            maxLength={50}
                                            disabled={isFieldLocked('applicationNo')}
                                        />
                                        <ErrorMessage
                                            name="applicationNo"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* College Name */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            College Name <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="collegeName"
                                            className={`form-control st-control ${formik.errors.collegeName && formik.touched.collegeName ? 'is-invalid' : ''}`}
                                            placeholder="Enter College Name"
                                            maxLength={100}
                                            disabled={isFieldLocked('collegeName')}
                                        />
                                        <ErrorMessage
                                            name="collegeName"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Name of the Student */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Name of the Student <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="studentName"
                                            className={`form-control st-control ${formik.errors.studentName && formik.touched.studentName ? 'is-invalid' : ''}`}
                                            placeholder="Enter Student Name"
                                            maxLength={100}
                                            onKeyPress={allowAlphabetAndSpacesOnly}
                                            disabled={isFieldLocked('studentName')}
                                        />
                                        <ErrorMessage
                                            name="studentName"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Father's Name */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Father's Name <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="fathersName"
                                            className={`form-control st-control ${formik.errors.fathersName && formik.touched.fathersName ? 'is-invalid' : ''}`}
                                            placeholder="Enter Father's Name"
                                            maxLength={100}
                                            onKeyPress={allowAlphabetAndSpacesOnly}
                                            disabled={isFieldLocked('fathersName')}
                                        />
                                        <ErrorMessage
                                            name="fathersName"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* District */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            District <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            as="select"
                                            name="district"
                                            className={`form-control st-control ${formik.errors.district && formik.touched.district ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('district')}
                                        >
                                            <option value="">Select District</option>
                                            {distlist?.map((district) => (
                                                <option key={district.dist_code} value={district.dist_code}>
                                                    {district.dist_name}
                                                </option>
                                            ))}
                                        </Field>
                                        <ErrorMessage
                                            name="district"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Gender */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Gender <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            as="select"
                                            name="gender"
                                            className={`form-control st-control ${formik.errors.gender && formik.touched.gender ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('gender')}
                                        >
                                            <option value="">Select Gender</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </Field>
                                        <ErrorMessage
                                            name="gender"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Country of Origin */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Country of Origin <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="countryOfOrigin"
                                            className={`form-control st-control ${formik.errors.countryOfOrigin && formik.touched.countryOfOrigin ? 'is-invalid' : ''}`}
                                            placeholder="Enter Country of Origin"
                                            maxLength={50}
                                            disabled={isFieldLocked('countryOfOrigin')}
                                        />
                                        <ErrorMessage
                                            name="countryOfOrigin"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Date of Birth */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Date of Birth <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="date"
                                            name="dateOfBirth"
                                            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
                                            className={`form-control st-control ${formik.errors.dateOfBirth && formik.touched.dateOfBirth ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('dateOfBirth')}
                                        />
                                        <ErrorMessage
                                            name="dateOfBirth"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>
                                </Row>
                            </div>

                            {/* Passport & Visa Information */}
                            <div className="mb-4">
                                <h4 className="border-bottom border-success pb-2 text-success">
                                    🛂 Passport & Visa Information
                                </h4>
                                <Row>
                                    {/* Passport Number */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Passport Number <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="text"
                                            name="passportNumber"
                                            className={`form-control st-control ${formik.errors.passportNumber && formik.touched.passportNumber ? 'is-invalid' : ''}`}
                                            placeholder="Enter Passport Number"
                                            maxLength={20}
                                            disabled={isFieldLocked('passportNumber')}
                                        />
                                        <ErrorMessage
                                            name="passportNumber"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Passport Issue Date */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Passport Issue Date <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="date"
                                            name="passportIssueDate"
                                            max={new Date().toISOString().split('T')[0]}
                                            className={`form-control st-control ${formik.errors.passportIssueDate && formik.touched.passportIssueDate ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('passportIssueDate')}
                                        />
                                        <ErrorMessage
                                            name="passportIssueDate"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Passport Expiry Date */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Passport Expiry Date <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="date"
                                            name="passportExpiryDate"
                                            min={formik.values.passportIssueDate || ''}
                                            className={`form-control st-control ${formik.errors.passportExpiryDate && formik.touched.passportExpiryDate ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('passportExpiryDate')}
                                        />
                                        <ErrorMessage
                                            name="passportExpiryDate"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Visa Issue Date */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Visa Issue Date <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="date"
                                            name="visaIssueDate"
                                            max={new Date().toISOString().split('T')[0]}
                                            className={`form-control st-control ${formik.errors.visaIssueDate && formik.touched.visaIssueDate ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('visaIssueDate')}
                                        />
                                        <ErrorMessage
                                            name="visaIssueDate"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Visa Expiry Date */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Visa Expiry Date <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            type="date"
                                            name="visaExpiryDate"
                                            min={formik.values.visaIssueDate || ''}
                                            className={`form-control st-control ${formik.errors.visaExpiryDate && formik.touched.visaExpiryDate ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('visaExpiryDate')}
                                        />
                                        <ErrorMessage
                                            name="visaExpiryDate"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>
                                </Row>
                            </div>

                            {/* Academic Information */}
                            <div className="mb-4">
                                <h4 className="border-bottom border-warning pb-2 text-success">
                                    📚 Academic Information
                                </h4>
                                <Row>
                                    {/* Course */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Course Category <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <BootstrapForm.Select
                                            name="courseCategory"
                                            value={formik.values.courseCategory || ''}
                                            className={`form-control st-control ${formik.errors.courseCategory && formik.touched.courseCategory && !formik.values.courseCategory ? 'is-invalid' : ''}`}
                                            onChange={(e) => handleCourseCategoryChange(e.target.value)}
                                            onBlur={() => {
                                                formik.setFieldTouched('courseCategory', true);
                                            }}
                                            disabled={isFieldLocked('courseCategory')}
                                        >
                                            <option value="">Select Course Category</option>
                                            {courseCategoryOptions.map((item) => (
                                                <option key={`category-${item}`} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </BootstrapForm.Select>
                                        <ErrorMessage
                                            name="courseCategory"
                                            component="div"
                                            className={`text-danger extra-small mt-1 ${formik.values.courseCategory ? 'd-none' : ''}`}
                                        />
                                    </Col>

                                    {/* Branch */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Course Name <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <BootstrapForm.Select
                                            name="courseName"
                                            value={formik.values.courseName || ''}
                                            className={`form-control st-control ${formik.errors.courseName && formik.touched.courseName && !formik.values.courseName ? 'is-invalid' : ''}`}
                                            onChange={(e) => handleCourseNameChange(e.target.value)}
                                            onBlur={() => {
                                                formik.setFieldTouched('courseCategory', true);
                                                formik.setFieldTouched('courseName', true);
                                            }}
                                            disabled={isFieldLocked('courseName')}
                                        >
                                            <option value="">Select Course Name</option>
                                            {courseNameOptions.map((item, index) => (
                                                <option key={`course-${item}-${index}`} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </BootstrapForm.Select>
                                        <ErrorMessage
                                            name="courseName"
                                            component="div"
                                            className={`text-danger extra-small mt-1 ${formik.values.courseName ? 'd-none' : ''}`}
                                        />
                                    </Col>

                                    {/* Category */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Category <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            as="select"
                                            name="category"
                                            className={`form-control st-control ${formik.errors.category && formik.touched.category ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('category')}
                                        >
                                            <option value="">Select Category</option>
                                            <option value="General">General</option>
                                            <option value="OBC">OBC</option>
                                            <option value="SC">SC</option>
                                            <option value="ST">ST</option>
                                            <option value="EWS">EWS</option>
                                        </Field>
                                        <ErrorMessage
                                            name="category"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Photo */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Photo <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.photo && formik.touched.photo ? 'is-invalid' : ''}`}
                                                accept="image/*"
                                                id="photo"
                                                name="photo"
                                                onChange={(e) => handleFileUpload(e, "photo", "image")}
                                                disabled={isFieldLocked('photo')}
                                            />
                                            {/* {filePreviews.photo && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.photo.name} ({filePreviews.photo.size})
                                            </small>
                                        )} */}
                                            {formik.values.photo && formik.values.photo !== '' && (
                                                <button className="btn btn-primary" size={20} type="button" onClick={() => {
                                                    viewImage(formik.values.photo);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="photo" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* Status */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Status <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <Field
                                            as="select"
                                            name="status"
                                            className={`form-control st-control ${formik.errors.status && formik.touched.status ? 'is-invalid' : ''}`}
                                            disabled={isFieldLocked('status')}
                                        >
                                            <option value="">Select Status</option>
                                            <option value="Pending">Pending</option>
                                            <option value="In Progress">In Progress</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Rejected">Rejected</option>
                                        </Field>
                                        <ErrorMessage
                                            name="status"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Antecedents Approved or not */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label d-block">
                                            Antecedents Approved or not <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex gap-4">
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="antecedentsApproved"
                                                id="antecedentsApprovedYes"
                                                label="Approved"
                                                value="Yes"
                                                checked={formik.values.antecedentsApproved === 'Yes'}
                                                disabled={isFieldLocked('antecedentsApproved')}
                                                onChange={(e) => {
                                                    handleApprovalChange('antecedentsApproved', e.target.value, 'antecedentsApprovedDoc');
                                                }}
                                            />
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="antecedentsApproved"
                                                id="antecedentsApprovedNo"
                                                label="Not Approved"
                                                value="No"
                                                checked={formik.values.antecedentsApproved === 'No'}
                                                disabled={isFieldLocked('antecedentsApproved')}
                                                onChange={(e) => {
                                                    handleApprovalChange('antecedentsApproved', e.target.value, 'antecedentsApprovedDoc');
                                                }}
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="antecedentsApproved"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Academic Credentials Verified or not */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label d-block">
                                            Academic Credentials Verified or not <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex gap-4">
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="academicCredentialsVerified"
                                                id="academicCredentialsVerifiedYes"
                                                label="Verified"
                                                value="Yes"
                                                checked={formik.values.academicCredentialsVerified === 'Yes'}
                                                disabled={isFieldLocked('academicCredentialsVerified')}
                                                onChange={(e) => {
                                                    handleApprovalChange('academicCredentialsVerified', e.target.value, 'academicCredentialsApproved');
                                                }}
                                            />
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="academicCredentialsVerified"
                                                id="academicCredentialsVerifiedNo"
                                                label="Not Verified"
                                                value="No"
                                                checked={formik.values.academicCredentialsVerified === 'No'}
                                                disabled={isFieldLocked('academicCredentialsVerified')}
                                                onChange={(e) => {
                                                    handleApprovalChange('academicCredentialsVerified', e.target.value, 'academicCredentialsApproved');
                                                }}
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="academicCredentialsVerified"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>

                                    {/* Final Approval */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label d-block">
                                            Final Approval <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex gap-4">
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="finalApproval"
                                                id="finalApprovalYes"
                                                label="Approved"
                                                value="Yes"
                                                checked={formik.values.finalApproval === 'Yes'}
                                                disabled={isFieldLocked('finalApproval')}
                                                onChange={(e) => {
                                                    handleApprovalChange('finalApproval', e.target.value, 'finalApprove');
                                                }}
                                            />
                                            <BootstrapForm.Check
                                                type="radio"
                                                name="finalApproval"
                                                id="finalApprovalNo"
                                                label="Not Approved"
                                                value="No"
                                                checked={formik.values.finalApproval === 'No'}
                                                disabled={isFieldLocked('finalApproval')}
                                                onChange={(e) => {
                                                    handleApprovalChange('finalApproval', e.target.value, 'finalApprove');
                                                }}
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="finalApproval"
                                            component="div"
                                            className="text-danger extra-small mt-1"
                                        />
                                    </Col>
                                </Row>
                            </div>

                            {/* Document Uploads Section */}
                            <div className="mb-4">
                                <h4 className="border-bottom border-warning pb-2 text-success">
                                    🗂️ Document Uploads
                                </h4>
                                <Row>
                                    {/* Passport */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Passport <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.passport && formik.touched.passport ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="passport"
                                                name="passport"
                                                onChange={(e) => handleFileUpload(e, "passport", "pdf")}
                                                disabled={isFieldLocked('passport')}
                                            />
                                            {/* {filePreviews.passport && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.passport.name} ({filePreviews.passport.size})
                                            </small>
                                        )} */}
                                            {formik.values.passport && formik.values.passport !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.passport);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>

                                        <ErrorMessage name="passport" component="div" className="text-danger extra-small mt-1" />
                                    </Col>


                                    {/* Visa */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            Visa <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.visa && formik.touched.visa ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="visa"
                                                name="visa"
                                                onChange={(e) => handleFileUpload(e, "visa", "pdf")}
                                                disabled={isFieldLocked('visa')}
                                            />
                                            {/* {filePreviews.visa && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.visa.name} ({filePreviews.visa.size})
                                            </small>
                                        )} */}
                                            {formik.values.visa && formik.values.visa !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    if (formik.values.visa) {
                                                        viewImage(formik.values.visa);
                                                    }
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="visa" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* SSC */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            SSC <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.ssc && formik.touched.ssc ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="ssc"
                                                name="ssc"
                                                onChange={(e) => handleFileUpload(e, "ssc", "pdf")}
                                                disabled={isFieldLocked('ssc')}
                                            />
                                            {/* {filePreviews.ssc && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.ssc.name} ({filePreviews.ssc.size})
                                            </small>
                                        )} */}
                                            {formik.values.ssc && formik.values.ssc !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.ssc);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="ssc" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* SSC Embassy Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            SSC Embassy Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.sscEmbassyCertificate && formik.touched.sscEmbassyCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="sscEmbassyCertificate"
                                                name="sscEmbassyCertificate"
                                                onChange={(e) => handleFileUpload(e, "sscEmbassyCertificate", "pdf")}
                                                disabled={isFieldLocked('sscEmbassyCertificate')}
                                            />
                                            {/* {filePreviews.sscEmbassyCertificate && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.sscEmbassyCertificate.name} ({filePreviews.sscEmbassyCertificate.size})
                                            </small>
                                        )} */}
                                            {formik.values.sscEmbassyCertificate && formik.values.sscEmbassyCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.sscEmbassyCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="sscEmbassyCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* SSC AP State Board Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            SSC AP State Board Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.sscAPStateBoardCertificate && formik.touched.sscAPStateBoardCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="sscAPStateBoardCertificate"
                                                name="sscAPStateBoardCertificate"
                                                onChange={(e) => handleFileUpload(e, "sscAPStateBoardCertificate", "pdf")}
                                                disabled={isFieldLocked('sscAPStateBoardCertificate')}
                                            />
                                            {/* {filePreviews.sscAPStateBoardCertificate && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.sscAPStateBoardCertificate.name} ({filePreviews.sscAPStateBoardCertificate.size})
                                            </small>
                                        )} */}
                                            {formik.values.sscAPStateBoardCertificate && formik.values.sscAPStateBoardCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.sscAPStateBoardCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="sscAPStateBoardCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* INTER */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            INTER <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.inter && formik.touched.inter ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="inter"
                                                name="inter"
                                                onChange={(e) => handleFileUpload(e, "inter", "pdf")}
                                                disabled={isFieldLocked('inter')}
                                            />
                                            {/* {filePreviews.inter && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.inter.name} ({filePreviews.inter.size})
                                            </small>
                                        )} */}
                                            {formik.values.inter && formik.values.inter !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.inter);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="inter" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* INTER Embassy Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            INTER Embassy Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.interEmbassyCertificate && formik.touched.interEmbassyCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="interEmbassyCertificate"
                                                name="interEmbassyCertificate"
                                                onChange={(e) => handleFileUpload(e, "interEmbassyCertificate", "pdf")}
                                                disabled={isFieldLocked('interEmbassyCertificate')}
                                            />
                                            {/* {filePreviews.interEmbassyCertificate && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.interEmbassyCertificate.name} ({filePreviews.interEmbassyCertificate.size})
                                            </small>
                                        )} */}
                                            {formik.values.interEmbassyCertificate && formik.values.interEmbassyCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.interEmbassyCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="interEmbassyCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* INTER AP State Board Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            INTER AP State Board Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.interAPStateBoardCertificate && formik.touched.interAPStateBoardCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="interAPStateBoardCertificate"
                                                name="interAPStateBoardCertificate"
                                                onChange={(e) => handleFileUpload(e, "interAPStateBoardCertificate", "pdf")}
                                                disabled={isFieldLocked('interAPStateBoardCertificate')}
                                            />
                                            {/* {filePreviews.interAPStateBoardCertificate && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.interAPStateBoardCertificate.name} ({filePreviews.interAPStateBoardCertificate.size})
                                            </small>
                                        )} */}
                                            {formik.values.interAPStateBoardCertificate && formik.values.interAPStateBoardCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.interAPStateBoardCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="interAPStateBoardCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* DEGREE */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            DEGREE <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.degree && formik.touched.degree ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="degree"
                                                name="degree"
                                                onChange={(e) => handleFileUpload(e, "degree", "pdf")}
                                                disabled={isFieldLocked('degree')}
                                            />
                                            {/* {filePreviews.degree && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.degree.name} ({filePreviews.degree.size})
                                            </small>
                                        )} */}
                                            {formik.values.degree && formik.values.degree !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.degree);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="degree" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* DEGREE Embassy Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            DEGREE Embassy Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.degreeEmbassyCertificate && formik.touched.degreeEmbassyCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="degreeEmbassyCertificate"
                                                name="degreeEmbassyCertificate"
                                                onChange={(e) => handleFileUpload(e, "degreeEmbassyCertificate", "pdf")}
                                                disabled={isFieldLocked('degreeEmbassyCertificate')}
                                            />
                                            {/* {filePreviews.degreeEmbassyCertificate && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.degreeEmbassyCertificate.name} ({filePreviews.degreeEmbassyCertificate.size})
                                            </small>
                                        )} */}
                                            {formik.values.degreeEmbassyCertificate && formik.values.degreeEmbassyCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.degreeEmbassyCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="degreeEmbassyCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* DEGREE AP State Board Certificate */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            DEGREE AP State Board Certificate <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.degreeAPStateBoardCertificate && formik.touched.degreeAPStateBoardCertificate ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="degreeAPStateBoardCertificate"
                                                name="degreeAPStateBoardCertificate"
                                                onChange={(e) => handleFileUpload(e, "degreeAPStateBoardCertificate", "pdf")}
                                                disabled={isFieldLocked('degreeAPStateBoardCertificate')}
                                            />
                                            {/* {filePreviews.degreeAPStateBoardCertificate && (
                                                <small className="text-muted d-block mt-1">
                                                    Uploaded: {filePreviews.degreeAPStateBoardCertificate.name} ({filePreviews.degreeAPStateBoardCertificate.size})
                                                </small>
                                            )} */}
                                            {formik.values.degreeAPStateBoardCertificate && formik.values.degreeAPStateBoardCertificate !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.degreeAPStateBoardCertificate);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="degreeAPStateBoardCertificate" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* TC */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            TC <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.tc && formik.touched.tc ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="tc"
                                                name="tc"
                                                onChange={(e) => handleFileUpload(e, "tc", "pdf")}
                                                disabled={isFieldLocked('tc')}
                                            />
                                            {/* {filePreviews.tc && (
                                                <small className="text-muted d-block mt-1">
                                                    Uploaded: {filePreviews.tc.name} ({filePreviews.tc.size})
                                                </small>
                                            )} */}
                                            {formik.values.tc && formik.values.tc !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.tc);
                                                }}>
                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="tc" component="div" className="text-danger extra-small mt-1" />
                                    </Col>

                                    {/* OTHERS */}
                                    <Col xs={12} md={6} lg={4} className="mb-3">
                                        <BootstrapForm.Label className="st-label">
                                            OTHERS <span className="text-danger">*</span>
                                        </BootstrapForm.Label>
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="file"
                                                className={`form-control st-control ${formik.errors.others && formik.touched.others ? 'is-invalid' : ''}`}
                                                accept=".pdf,.jpg,.jpeg,.png"
                                                id="others"
                                                name="others"
                                                onChange={(e) => handleFileUpload(e, "others", "pdf")}
                                                disabled={isFieldLocked('others')}
                                            />
                                            {/* {filePreviews.others && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.others.name} ({filePreviews.others.size})
                                            </small>
                                        )} */}
                                            {formik.values.others && formik.values.others !== '' && (
                                                <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                    viewImage(formik.values.others);
                                                }}>

                                                    <FaEye />
                                                </button>
                                            )}
                                        </div>
                                        <ErrorMessage name="others" component="div" className="text-danger extra-small mt-1" />
                                    </Col>
                                </Row>
                            </div>

                            {/* Final Approvals Section */}
                            <div className="mb-4">
                                {(formik.values.antecedentsApproved === "Yes" || formik.values.academicCredentialsVerified === "Yes" || formik.values.finalApproval === "Yes") && (
                                    <h4 className="border-bottom border-danger pb-2 text-success">
                                        Final Approvals
                                    </h4>
                                )}
                                <Row>
                                    {/* Antecedents Approved */}
                                    {formik.values.antecedentsApproved === "Yes" && (
                                        <Col xs={12} md={6} lg={4} className="mb-3">
                                            <BootstrapForm.Label className="st-label">
                                                Antecedents Approved <span className="text-danger">*</span>
                                            </BootstrapForm.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <input
                                                    type="file"
                                                    className={`form-control st-control ${formik.errors.antecedentsApprovedDoc && formik.touched.antecedentsApprovedDoc ? 'is-invalid' : ''}`}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    id="antecedentsApprovedDoc"
                                                    name="antecedentsApprovedDoc"
                                                    onChange={(e) => handleFileUpload(e, "antecedentsApprovedDoc", "pdf")}
                                                    disabled={isFieldLocked('antecedentsApprovedDoc')}
                                                />
                                                {/* {filePreviews.antecedentsApprovedDoc && (
                                            <small className="text-muted d-block mt-1">
                                                Uploaded: {filePreviews.antecedentsApprovedDoc.name} ({filePreviews.antecedentsApprovedDoc.size})
                                            </small>
                                        )} */}
                                                {formik.values.antecedentsApprovedDoc && formik.values.antecedentsApprovedDoc !== '' && (
                                                    <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                        viewImage(formik.values.antecedentsApprovedDoc);
                                                    }}>
                                                        <FaEye />
                                                    </button>
                                                )}
                                            </div>

                                            <ErrorMessage name="antecedentsApprovedDoc" component="div" className="text-danger extra-small mt-1" />
                                        </Col>
                                    )}
                                    {/* Academic Credentials Approved */}
                                    {formik.values.academicCredentialsVerified === "Yes" && (
                                        <Col xs={12} md={6} lg={4} className="mb-3">
                                            <BootstrapForm.Label className="st-label">
                                                Academic Credentials Approved <span className="text-danger">*</span>
                                            </BootstrapForm.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <input
                                                    type="file"
                                                    className={`form-control st-control ${formik.errors.academicCredentialsApproved && formik.touched.academicCredentialsApproved ? 'is-invalid' : ''}`}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    id="academicCredentialsApproved"
                                                    name="academicCredentialsApproved"
                                                    onChange={(e) => handleFileUpload(e, "academicCredentialsApproved", "pdf")}
                                                    disabled={isFieldLocked('academicCredentialsApproved')}
                                                />
                                                {/* {filePreviews.academicCredentialsApproved && (
                                                <small className="text-muted d-block mt-1">
                                                    Uploaded: {filePreviews.academicCredentialsApproved.name} ({filePreviews.academicCredentialsApproved.size})
                                                </small>
                                            )} */}
                                                {formik.values.academicCredentialsApproved && formik.values.academicCredentialsApproved !== '' && (
                                                    <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                        if (formik.values.academicCredentialsApproved) {
                                                            viewImage(formik.values.academicCredentialsApproved);
                                                        }
                                                    }}>
                                                        <FaEye />
                                                    </button>
                                                )}
                                            </div>
                                            <ErrorMessage name="academicCredentialsApproved" component="div" className="text-danger extra-small mt-1" />
                                        </Col>
                                    )}
                                    {/* Final Approve */}

                                    {formik.values.finalApproval === "Yes" && (
                                        <Col xs={12} md={6} lg={4} className="mb-3">
                                            <BootstrapForm.Label className="st-label">
                                                Final Approve <span className="text-danger">*</span>
                                            </BootstrapForm.Label>
                                            <div className="d-flex align-items-center gap-2">
                                                <input
                                                    type="file"
                                                    className={`form-control st-control ${formik.errors.finalApprove && formik.touched.finalApprove ? 'is-invalid' : ''}`}
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                    id="finalApprove"
                                                    name="finalApprove"
                                                    onChange={(e) => handleFileUpload(e, "finalApprove", "pdf")}
                                                    disabled={isFieldLocked('finalApprove')}
                                                />
                                                {/* {filePreviews.finalApprove && (
                                                    <small className="text-muted d-block mt-1">
                                                        Uploaded: {filePreviews.finalApprove.name} ({filePreviews.finalApprove.size})
                                                    </small>
                                                )} */}
                                                {formik.values.finalApprove && formik.values.finalApprove !== '' && (
                                                    <button className="btn btn-primary" size={18} type="button" onClick={() => {
                                                        if (formik.values.finalApprove) {
                                                            viewImage(formik.values.finalApprove);
                                                        }
                                                    }}>
                                                        <FaEye />
                                                    </button>
                                                )}
                                            </div>
                                            <ErrorMessage name="finalApprove" component="div" className="text-danger extra-small mt-1" />
                                        </Col>
                                    )}
                                </Row>
                            </div>

                            {/* Submit Button */}
                            {!hasValue(formik.values.status) && (
                                <Row>
                                    <Col className="d-flex justify-content-end gap-2">
                                        <Button
                                            type="reset"
                                            variant="secondary"
                                            onClick={() => {
                                                formik.resetForm();
                                                setFilePreviews({});
                                            }}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="primary"
                                        // disabled={formik.isSubmitting}
                                        >
                                            Submit
                                        </Button>
                                    </Col>
                                </Row>
                            )}

                        </Form>
                    </FormikProvider>
                </div>
            </section>
        </Container >
    )
}